export const CONFIG_FETCH_TIMEOUT_MS = 8000;
// WHY: a frozen, offline or stalled shell emits no further plugin event, and the splash must still lift.
export const FIRST_LAUNCH_SETTLE_TIMEOUT_MS = 10000;
export const GUARD_BOOT_TIMEOUT_MS = 12000;
export const SPLASH_SAFETY_MS = 15000;
export const BOOT_STALLED_MS = 20000;
export const BOOT_UNREACHABLE_REPORT_MS = 60000;
